export interface NavItem {
	id: number;
	name: string;
	link: string;
	icon: string;
}

export const COMMUNITY_OPTIONS: NavItem[] = [
	{ id: 0, name: 'Property Group Home', link: '/', icon: '/assets/icons/community/Community.svg' },
	{ id: 1, name: 'Profile', link: 'profile', icon: '/assets/icons/community/profile.svg' },
	{ id: 4, name: 'Cost Centers', link: 'costcenters', icon: '/assets/icons/community/costcenters.svg' },
	{ id: 5, name: 'Property Subgroups', link: 'buildings', icon: '/assets/icons/community/buildings.svg' },
	{ id: 6, name: 'Units', link: 'units', icon: '/assets/icons/community/units.svg' },
	{ id: 7, name: 'Owners Association', link: 'oa', icon: '/assets/icons/community/oa.svg' },
	{ id: 8, name: "Helpline & FAQ's", link: 'helpline-faq', icon: '/assets/icons/community/importantinformation.svg' },
	{ id: 10, name: 'Event Calendar', link: 'event-calendar', icon: '/assets/icons/community/eventcalendar.svg' },
	{ id: 12, name: 'Accounting', link: 'accounting', icon: '/assets/icons/community/accounting.svg' },
	{ id: 15, name: 'Work Orders', link: 'workorders', icon: '/assets/icons/community/workorders.svg' },
	{ id: 16, name: 'Documents', link: 'documents', icon: '/assets/icons/community/documents.svg' },
	{ id: 18, name: 'Facilities', link: 'facilities', icon: '/assets/icons/community/eventcalendar.svg' },
	{ id: 17, name: 'Integrations', link: 'integrations', icon: '/assets/icons/ledgerv2-icons/adjustments.svg' },
	{ id: 19, name: 'Property Group Settings', link: 'community-settings', icon: '/assets/icons/community/community-settings.svg' },
	{ id: 20, name: 'Terms & Conditions', link: 'terms-conds', icon: '/assets/icons/community/terms.svg' },
	{ id: 21, name: "Contracts' Terms", link: 'contracts-terms-conditions', icon: '/assets/icons/settings/acclist.svg' },
];

export const PM_UNITS_ITEM: NavItem = {
	id: 23, name: 'PM Units', link: 'pm-units', icon: '/assets/icons/community/units.svg',
};

export const ACCOUNTING_OPTIONS: NavItem[] = [
	{ id: 0, name: 'Accounting Home', link: '/accounting/', icon: '/assets/icons/community/accounting.svg' },
	{ id: 1, name: 'Unit Financials', link: '/accounting/unit-financials', icon: '/assets/icons/ledgerv2-icons/unit-based-revenue.svg' },
	{ id: 2, name: 'Customers & Sales', link: '/accounting/sales', icon: '/assets/icons/ledgerv2-icons/customers-sales.svg' },
	{ id: 4, name: 'Purchases', link: '/accounting/purchases', icon: '/assets/icons/ledgerv2-icons/vendors-purchases.svg' },
	{ id: 5, name: 'General Ledger', link: '/accounting/gl', icon: '/assets/icons/ledgerv2-icons/general-ledger.svg' },
	{ id: 6, name: 'General Ledger New View', link: '/accounting/general-ledger', icon: '/assets/icons/ledgerv2-icons/general-ledger.svg' },
	{ id: 7, name: 'Cash & Cheque Movements', link: '/accounting/cp', icon: '/assets/icons/ledgerv2-icons/cash-position.svg' },
	{ id: 8, name: 'Adjustments', link: '/accounting/adjustments', icon: '/assets/icons/ledgerv2-icons/adjustments.svg' },
	{ id: 9, name: 'Reports', link: '/accounting/report', icon: '/assets/icons/ledgerv2-icons/reports.svg' },
	{ id: 10, name: 'Financial Settings', link: '/accounting/financial-settings', icon: '/assets/icons/ledgerv2-icons/management.svg' },
	{ id: 11, name: 'Budgets', link: 'budgets', icon: '/assets/icons/community/budgets.svg' },
];

export const CHART_OF_ACCOUNTS_ITEM: NavItem = {
	id: 3, name: 'Chart of Accounts', link: '/accounting/chart-accounts', icon: '/assets/icons/settings/acclist.svg',
};

export const ADMINISTRATION_LIST: NavItem[] = [
	{ id: 0, name: 'Administration Home', link: 'administration', icon: '/assets/icons/user.svg' },
	{ id: 1, name: 'General Settings', link: 'administration/general-settings', icon: '/assets/icons/administration/settings.svg' },
	{ id: 2, name: 'Users', link: 'users', icon: '/assets/icons/administration/users.svg' },
	{ id: 3, name: 'Account List', link: 'administration/acclist', icon: '/assets/icons/settings/acclist.svg' },
	{ id: 4, name: 'Mail Sending', link: 'administration/mail-sending', icon: '/assets/icons/settings/mail-sending.svg' },
	{ id: 5, name: 'Contacts', link: 'contact-ledger', icon: '/assets/icons/administration/contacts.svg' },
	{ id: 10, name: 'Integrations', link: 'administration/integrations', icon: '/assets/icons/ledgerv2-icons/adjustments.svg' },
	{ id: 11, name: 'Land Lords', link: 'administration/landlords', icon: '/assets/icons/administration/landlords.svg' },
	{ id: 13, name: 'Access Control', link: 'administration/management', icon: '/assets/icons/administration/Accessrights.svg' },
	{ id: 8, name: 'Voiding Requests', link: 'administration/voiding-requests', icon: '/assets/icons/ledgerv2-icons/voiding-requests.svg' },
];

export const GLOBAL_ADMINISTRATION_LIST: NavItem[] = [
	{ id: 0, name: 'Global Administration Home', link: '', icon: '/assets/icons/user.svg' },
	{ id: 1, name: 'Global Account List', link: 'acclist', icon: '/assets/icons/settings/acclist.svg' },
	{ id: 2, name: 'Clients', link: 'clients', icon: '/assets/icons/administration/clients.svg' },
	{ id: 3, name: 'Users', link: 'users-list', icon: '/assets/icons/administration/users.svg' },
	{ id: 4, name: 'Service Categories', link: 'service-category-types', icon: '/assets/icons/administration/settings.svg' },
];

export const SETTINGS_ADMINISTRATION_LIST: NavItem[] = [
	{ id: 0, name: 'Settings Home', link: 'settings/', icon: '/assets/icons/administration/settings.svg' },
	{ id: 1, name: 'Account List', link: 'settings/acclist', icon: '/assets/icons/settings/acclist.svg' },
	{ id: 3, name: 'SMTP', link: 'settings/smtp', icon: '/assets/icons/settings/smtp.svg' },
	{ id: 4, name: 'MailGun', link: 'settings/mailgun', icon: '/assets/icons/settings/mailgun.svg' },
];

export const REQUESTS_ADMINISTRATION_LIST: NavItem[] = [
	{ id: 0, name: 'Requests Home', link: 'request-admin/', icon: '/assets/icons/administration/requests.svg' },
	{ id: 1, name: 'Move-In List', link: 'request-admin/move-in/list', icon: '/assets/icons/administration/Move-In.svg' },
];

export const FACILITIES_ADMINISTRATION_LIST: NavItem[] = [
	{ id: 0, name: 'Facilities Home', link: '/facilities', icon: '/assets/icons/community/Community.svg' },
	{ id: 1, name: 'Facilities', link: '/facilities/facilities', icon: '/assets/icons/community/buildings.svg' },
	{ id: 2, name: 'Settings', link: '/facilities/settings', icon: '/assets/icons/administration/settings.svg' },
];
